<div class="show-process">
	<ng-container [ngSwitch]="process">
		<ng-container *ngSwitchCase="PROCESS_STATUS.loading">
			<div class="animated fadeIn">
				<div class="show-process__icon loading">
					<svg class="show-process__svg-circular" viewBox="25 25 50 50">
						<circle class="show-process__svg-path" cx="50" cy="50" r="20"
										fill="none"
										stroke-width="2"
										stroke-miterlimit="10"/>
					</svg>
				</div>
				<p class="show-process__text loading">{{process}}</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="PROCESS_STATUS.validating">
			<div class="animated fadeIn">
				<div class="show-process__icon loading">
					<svg class="show-process__svg-circular" viewBox="25 25 50 50">
						<circle class="show-process__svg-path" cx="50" cy="50" r="20"
										fill="none"
										stroke-width="2"
										stroke-miterlimit="10"/>
					</svg>
				</div>
				<p class="show-process__text loading">{{process}}</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="PROCESS_STATUS.statusChecking">
			<div class="animated fadeIn">
				<div class="show-process__icon loading">
					<svg class="show-process__svg-circular" viewBox="25 25 50 50">
						<circle class="show-process__svg-path" cx="50" cy="50" r="20"
										fill="none"
										stroke-width="2"
										stroke-miterlimit="10"/>
					</svg>
				</div>
				<p class="show-process__text loading">{{process}}</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="PROCESS_STATUS.created">
			<div class="animated fadeIn">
				<div class="show-process__icon done"></div>
				<p class="show-process__text done">{{process}}</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="PROCESS_STATUS.done">
			<div class="animated fadeIn">
				<div class="show-process__icon done"></div>
				<p class="show-process__text done">{{process}}</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="PROCESS_STATUS.saved">
			<div class="animated fadeIn">
				<div class="show-process__icon done"></div>
				<p class="show-process__text done">{{process}}</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchCase="PROCESS_STATUS.failed">
			<div class="animated fadeIn">
				<div class="show-process__icon failed"></div>
				<p class="show-process__text failed">{{process}}</p>
			</div>
		</ng-container>
		<ng-container *ngSwitchDefault>
			<div class="animated fadeIn">
				<div class="show-process__icon"></div>
				<p class="show-process__text">A lot of process are doing right now, just wait a little bit</p>
			</div>
		</ng-container>
	</ng-container>
</div>
